import { REPORTS_ROUTES } from '../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'

import reportsTypes from '../constants/reportsTypes'
// import forms_types from '../constants/formsTypes'
import { axios } from '../services'

import { try_force_logoff } from './authActions'

const reset_report_errors = () => {
  return {
    type: reportsTypes.reset_errors
  }
}

const set_current_report = ( report ) => {
  return {
    type: "SET_CURRENT_REPORT",
    payload: report
  }
}

const show_sidebar_report_actions = () => {
  return {
    type: "SHOW_SIDEBAR_REPORT_ACTIONS"
  }
}

const hide_sidebar_report_actions = () => {
  return {
    type: "HIDE_SIDEBAR_REPORT_ACTIONS"
  }
}

// GET Project
const get_project_request = () => {
  return {
    type: reportsTypes.get.request
  }
}

const get_project_refresh_request = () => {
  return {
    type: reportsTypes.get.refresh_request
  }
}


const get_project_success = (response) => {
  return {
    type: reportsTypes.get.success,
    payload: response.data.report
  }
}

const get_project_success_excel = () => {
  return {
    type: reportsTypes.get.success_excel,
  }
}

const get_project_minimal_success = (response) => {
  return {
    type: reportsTypes.get.success_minimal,
    payload: response.data
  }
}

const get_project_failure = (messages) => {
  return {
    type: reportsTypes.get.failure,
    payload: messages
  }
}

const reset_report_redirect = () => {
  return {
    type: reportsTypes.get.reset_redirect
  }
}

const get_project = (report_id, page = 1, refresh=false, show="standard") => {
  return function(dispatch) {
    // Before Request
    if (refresh) {
      dispatch(get_project_refresh_request())
    } else {
      dispatch(get_project_request())
    }

    // Request
    axios.get(
      formatRoute(REPORTS_ROUTES.get, {id: report_id}),
      {
        params: {
          page: page,
          per_page: 10,
          show: show
        }
      }
    ).then( response => {
      // success
      if ( ! refresh ) {
        dispatch( reset_report_redirect() )
      }
      if ( show === "minimal" ) {
        dispatch( get_project_minimal_success(response) )
      } else {
        dispatch( get_project_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [error]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( get_project_failure(errors) )
    })
  }
}

// export xlsx from report entries
const export_report = (report_id) => {
  return function(dispatch) {
    // Before Request
    dispatch(get_project_request())

    // Request
    axios.get(
      formatRoute(REPORTS_ROUTES.export, {id: report_id}),
      {
        responseType: 'blob',
      }
    ).then( response => {
      // success
      // dispatch( get_project_success(response) )
      const blob = URL.createObjectURL(response.data, 'exported_xlsx')
      console.log(blob)
      const element = document.createElement('a')
      document.body.appendChild(element)
      element.style = 'display:none'
      element.href = blob
      element.download = `report_${report_id}.xlsx`
      element.click();
      dispatch(get_project_success_excel())

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [error]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( get_project_failure(errors) )
    })
  }
}

// Create Optimized report
const create_optimized_request = () => {
  return {
    type: reportsTypes.create_optimized.request
  }
}

const create_optimized_success = (response) => {
  return {
    type: reportsTypes.create_optimized.success,
    payload: response.data.report
  }
}

const create_optimized_failure = (messages) => {
  return {
    type: reportsTypes.create_optimized.failure,
    payload: messages
  }
}

const create_optimized_report = ( report_id, reportData ) => {
  return function(dispatch) {
    // Before Request
    dispatch(create_optimized_request())

    // Request
    const { name } = reportData
    axios.post(
      formatRoute(REPORTS_ROUTES.create_optimized, {id: report_id}),
      {
        report: {
          name: name
        }
      }
    ).then( response => {
      // success
      dispatch( create_optimized_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating optimized report."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( create_optimized_failure(errors) )
    })
  }
}


// Create REPORT
const create_project_request = () => {
  return {
    type: reportsTypes.create.request
  }
}

const create_project_success = (response) => {
  return {
    type: reportsTypes.create.success,
    payload: response.data.report
  }
}

const create_project_failure = (messages) => {
  return {
    type: reportsTypes.create.failure,
    payload: messages
  }
}

const create_project= (reportData) => {
  return function(dispatch) {
    // Before Request
    dispatch(create_project_request())

    // Request
    // let { url, name, http_user, http_pass } = reportData
    console.log("reportData")
    console.log(reportData)
    axios.post(
      REPORTS_ROUTES.create,
      reportData
      // {
      //   // report: {
      //   //   url: url,
      //   //   name: name,
      //   //   http_user: http_user,
      //   //   http_pass: http_pass
      //   // }
      //   report: reportData
      // }
    ).then( response => {
      // success
      dispatch( create_project_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating report."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( create_project_failure(errors) )
    })
  }
}

// Get REPORTS
const reports_index_request = () => {
  return {
    type: reportsTypes.index.request
  }
}

const reports_index_success = (response) => {
  return {
    type: reportsTypes.index.success,
    payload: response.data
  }
}

const reports_index_failure = (messages) => {
  return {
    type: reportsTypes.index.failure,
    payload: messages
  }
}

const reports_index = (page) => {
  return function (dispatch) {
    // Before Request
    dispatch(reports_index_request())

    // Request
    axios.get(
      REPORTS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( reports_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching reports."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( reports_index_failure(errors))
    })
  }
}

export {
  reset_report_errors,
  set_current_report,
  show_sidebar_report_actions,
  hide_sidebar_report_actions,
  reports_index,
  get_project,
  create_project,
  create_optimized_report,
  export_report
}

export * from './reports'



// WEBPACK FOOTER //
// ./src/js/actions/reportsActions.js